// Imports
import { useState, useEffect } from 'react';

const usePersistStore = (store, callback) => {
  const result = store(callback);
  const [data, setData] = useState();

  useEffect(() => {
    if (result) {
      setData(result);
    }
  }, [result]);

  return data;
};

export default usePersistStore;
